import L from 'leaflet'
import VectorMarkers from './VectorMarkers'
import './leaflet-vector-markers.scss'

L.VectorMarkers = VectorMarkers;
